import React from 'react';

const Hero = () => {
  const handleSectionClick = (sectionId) => {
    // Simple scroll to section without router dependency
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="home" className="hero-gradient py-24 lg:py-32 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/50 via-transparent to-accent-50/30"></div>
      
      <div className="container relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-20">
          {/* Hero Image */}
          <div className="flex-shrink-0 animate-fade-in">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-primary-500/20 to-accent-500/20 rounded-full blur-3xl"></div>
              <img 
                src="/img/dr.Adesh.Palyekar.png" 
                alt="Dr. Adesh Palyekar" 
                className="relative w-64 h-64 lg:w-80 lg:h-80 rounded-full object-cover shadow-2xl border-4 border-white/80"
              />
            </div>
          </div>
          
          {/* Hero Content */}
          <div className="flex-1 text-center lg:text-left animate-slide-up">
            <div className="mb-6">
              <h1 className="font-display text-5xl lg:text-7xl font-black text-blue-800 mb-4 leading-tight">
                Dr. Adesh Palyekar
              </h1>
              
              <h2 className="font-accent text-xl lg:text-2xl font-semibold text-text-secondary mb-6">
                M.B.B.S. M.S. M.Ch. <span className="text-gradient-gold font-bold">(Gold Medalist)</span>
              </h2>
            </div>
            
            <p className="text-xl lg:text-2xl text-text-secondary mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              Distinguished Cancer Surgeon serving Goa, Maharashtra & Konkan. 
              <span className="text-primary-600 font-semibold"> Trusted for advanced, compassionate care.</span>
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button 
                onClick={() => handleSectionClick('contact')} 
                className="btn-primary text-lg px-10 py-5 inline-flex items-center gap-3"
              >
                <i className="fas fa-calendar-check"></i>
                Book Appointment
              </button>
              
              <button 
                onClick={() => handleSectionClick('services')} 
                className="btn-secondary text-lg px-10 py-5 inline-flex items-center gap-3"
              >
                <i className="fas fa-stethoscope"></i>
                Our Services
              </button>
            </div>

            {/* Trust Indicators */}
            <div className="mt-12 flex flex-wrap justify-center lg:justify-start gap-8 text-sm text-text-secondary">
              <div className="flex items-center gap-2">
                <i className="fas fa-award text-gold-500"></i>
                <span>Gold Medalist</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="fas fa-user-md text-medical-500"></i>
                <span>Expert Surgeon</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="fas fa-heart text-accent-500"></i>
                <span>Compassionate Care</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 